import { alpha } from '@mui/system/colorManipulator';
import type { ColorRange, PaletteColor } from '@mui/material/styles/createPalette';

const withAlphas = (color: PaletteColor): PaletteColor => {
  return {
    ...color,
    alpha4: alpha(color.main, 0.04),
    alpha8: alpha(color.main, 0.08),
    alpha12: alpha(color.main, 0.12),
    alpha30: alpha(color.main, 0.30),
    alpha50: alpha(color.main, 0.50)
  };
};

export const neutral: ColorRange = {
  50: '#F8F9FA',
  100: '#F3F4F6',
  200: '#E5E7EB',
  300: '#D2D6DB',
  400: '#9DA4AE',
  500: '#6C737F',
  600: '#4D5761',
  700: '#2F3746',
  800: '#1C2536',
  900: '#111927'
};

export const blue = withAlphas({
  lightest: '#F5F8FF',
  light: '#EBEFFF',
  main: '#2970FF',
  dark: '#004EEB',
  darkest: '#00359E',
  contrastText: '#FFFFFF'
});

export const green = withAlphas({
  lightest: '#F6FEF9',
  light: '#EDFCF2',
  main: '#16B364',
  dark: '#087443',
  darkest: '#084C2E',
  contrastText: '#FFFFFF'
});

export const indigo = withAlphas({
  lightest: '#F5F7FF',
  light: '#EBEEFE',
  main: '#6366F1',
  dark: '#4338CA',
  darkest: '#312E81',
  contrastText: '#FFFFFF'
});

export const purple = withAlphas({
  lightest: '#F9F5FF',
  light: '#F4EBFF',
  main: '#9E77ED',
  dark: '#6941C6',
  darkest: '#42307D',
  contrastText: '#FFFFFF'
});

export const navy = withAlphas({
  lightest: '#F1F4FB',
  light: '#DDE3F3',
  main: '#1E3A8A',
  dark: '#152C6B',
  darkest: '#0E1E4A',
  contrastText: '#FFFFFF'
});

export const forest = withAlphas({
  lightest: '#F0F7F2',
  light: '#D7E9DC',
  main: '#166534',
  dark: '#0F4C25',
  darkest: '#0A3318',
  contrastText: '#FFFFFF'
});

export const burgundy = withAlphas({
  lightest: '#FBF1F3',
  light: '#F3D9DF',
  main: '#9F1239',
  dark: '#7C0E2C',
  darkest: '#59091F',
  contrastText: '#FFFFFF'
});

export const charcoal = withAlphas({
  lightest: '#F4F5F7',
  light: '#E1E4E9',
  main: '#334155',
  dark: '#24303F',
  darkest: '#18212C',
  contrastText: '#FFFFFF'
});

export const success = withAlphas({
  lightest: '#DFF1E5',
  light: '#5FBD8A',
  main: '#1F8A55',
  dark: '#155D3B',
  darkest: '#0A3D24',
  contrastText: '#FFFFFF'
});

export const info = withAlphas({
  lightest: '#ECFDFF',
  light: '#CFF9FE',
  main: '#06AED4',
  dark: '#0E7090',
  darkest: '#164C63',
  contrastText: '#FFFFFF'
});

export const warning = withAlphas({
  lightest: '#FFFAEB',
  light: '#FEF0C7',
  main: '#F79009',
  dark: '#B54708',
  darkest: '#7A2E0E',
  contrastText: '#FFFFFF'
});

export const error = withAlphas({
  lightest: '#FEF3F2',
  light: '#FEE4E2',
  main: '#F04438',
  dark: '#B42318',
  darkest: '#7A271A',
  contrastText: '#FFFFFF'
});
